import { ChangeDetectionStrategy, Component, forwardRef, OnInit, Provider, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TimePeriodPickerBaseComponent } from '@luggagehero/features/ui';

import { DateTimePickerComponent } from '../date-time-picker/date-time-picker.component';

export const TIME_PERIOD_PICKER_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TimePeriodPickerComponent),
  multi: true,
};

@Component({
  selector: 'lh-time-period-picker',
  templateUrl: './time-period-picker.component.html',
  styleUrls: ['./time-period-picker.component.scss'],
  providers: [TIME_PERIOD_PICKER_CONTROL_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TimePeriodPickerComponent extends TimePeriodPickerBaseComponent implements OnInit, ControlValueAccessor {
  @ViewChild('fromPicker') fromDateTimePicker: DateTimePickerComponent;
  @ViewChild('toPicker') toDateTimePicker: DateTimePickerComponent;
}
